import { Component, OnDestroy } from '@angular/core';
import { EnvironmentListService } from '@modules/common/services/environment-list.service';
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';
import { merge, Subscription } from 'rxjs';

@Component({
    selector: 'app-nav-header',
    templateUrl: './nav-header.component.html',
    styleUrls: ['./nav-header.component.scss']
})
export class NavHeaderComponent implements OnDestroy {
    public nonDefaultEnvironmentSelected = false;

    private readonly _subscription: Subscription;

    constructor(
        private _environmentListService: EnvironmentListService,
        private _currentEnvironmentService: CurrentEnvironmentService
    ) {
        this._subscription = merge(this._currentEnvironmentService.environmentChanged, this._environmentListService.environmentListChanged)
            .subscribe(() => this.updateEnvironment());
    }

    public ngOnDestroy(): void {
        this._subscription.unsubscribe();
    }

    private updateEnvironment(): void {
        const environmentName = this._currentEnvironmentService.getCurrentEnvironmentName();
        const environment = this._environmentListService.getEnvironmentList().filter(x => x.name.toLowerCase() == environmentName.toLowerCase())[0];
        this.nonDefaultEnvironmentSelected = environment && !environment.isDefault;
    }
}
